import { Dispatch } from 'redux';
import { profileAPI } from '../api/api.ts'
import { photosType, postsType, profileType } from '../Type/Type';
import { ThunkAction } from 'redux-thunk';
import { RootState } from './redux-store';

const ADD_POST = 'ADD-POST';
const SET_PROFILE_USER = 'SET_PROFILE_USER';
const SET_STATUS = 'SET_STATUS';
const DELETINT_POST = 'DELETINT_POST';
const SAVE_PHOTO_SUCCESS = 'SAVE_PHOTO_SUCCESS';

let initialState = {
    posts: [
        { id: 1, text: 'Its my first post', likeCount: 23 },
        { id: 2, text: 'How are you?', likeCount: 13 },
        { id: 3, text: 'How are you?', likeCount: 13 },
        { id: 4, text: 'FUCH STATE?', likeCount: 13 },
        { id: 5, text: 'How are you?', likeCount: 13 },
        { id: 6, text: 'Oh, shit?', likeCount: 13 },
    ] as Array<postsType>,
    profile: null as profileType | null,
    status: 'gi',
}

export type initialStateType = typeof initialState

let profileReduce = (state = initialState, action: ActionTypes):initialStateType  => {
    switch (action.type) {
        case ADD_POST:
            let newPost = {
                id: 7,
                text: action.addPostText,
                likeCount: 0,
            }
            return {
                ...state,
                posts: [...state.posts, newPost],
            }
        case SET_PROFILE_USER:
            return {
                ...state,
                profile: action.profile,
            }
        case SET_STATUS:
            return {
                ...state,
                status: action.status,
            }
        case DELETINT_POST: 
            return {
                ...state,
                posts: state.posts.filter(p => p.id != action.postId),
            }
        case SAVE_PHOTO_SUCCESS: {
            return {
                ...state,
                profile: {...state.profile, photos: action.photos} as profileType,
            }
        }
        default:
            return state;
    }
}

type ActionTypes = addPostActionCreateActionType | deletingPostActionType | setUserProfileActionType | setStatusActionType | savePhotoSuccessActionType

type addPostActionCreateActionType = {
    type: typeof ADD_POST
    addPostText: string
}
export const addPostActionCreate = (addPostText: string):addPostActionCreateActionType => ({type: ADD_POST,addPostText});

type deletingPostActionType = {
    type: typeof DELETINT_POST
    postId: number
}
export const deletingPost = (postId: number):deletingPostActionType => ({type: DELETINT_POST, postId});

type setUserProfileActionType = {
    type: typeof SET_PROFILE_USER
    profile: profileType
}
export const setUserProfile = (profile:profileType):setUserProfileActionType  => ({type: SET_PROFILE_USER, profile});

type setStatusActionType = {
    type: typeof SET_STATUS
    status: string
}
export const setStatus = (status: string):setStatusActionType  => ({type: SET_STATUS, status});

type savePhotoSuccessActionType = {
    type: typeof SAVE_PHOTO_SUCCESS
    photos: photosType
}
export const savePhotoSuccess = (photos: photosType):savePhotoSuccessActionType  => ({type: SAVE_PHOTO_SUCCESS, photos});

type GetStateType = () => RootState
type DispatchType = Dispatch<ActionTypes>
type ThunkType = ThunkAction<Promise<void>, RootState, unknown, ActionTypes>

export const getProfileThunk = (userId: number): ThunkType => async (dispatch, setState) => {
    let response = await profileAPI.getProfile(userId)
    dispatch(setUserProfile(response.data));
}

export const getStatus = (userId: number): ThunkType => async (dispatch, setState) => {
        let response = await profileAPI.getUserStatus(userId)
            dispatch(setStatus(response.data));

    }

export const updateStatus = (status: string) => {
    return (dispatch: DispatchType, setState: GetStateType) => {
        profileAPI.updateUserStatus(status)
        .then((data) => {
            if (data.resultCode === 0) {
              dispatch(setStatus(status));
            }
        })
    }
}

export const savePhoto = (file: any): ThunkType => async (dispatch, setState) => {
    const response = await profileAPI.savePhoto(file);
    if(response.data.resultCode === 0) {
        dispatch(savePhotoSuccess(response.data.data.photos));
    }
}

export const saveProfile = (profile: profileType): ThunkType => async (dispatch ,getState: any) => {
   const userId = getState().auth.id
    const response = await profileAPI.getSaveProfile(profile);
    if(response.data.resultCode === 0) {
      dispatch(getProfileThunk(userId));
    }
}

export default profileReduce;